import type { ApiModuleEndpoints } from '../types'
export const shiftRevenueReportApiEndpoints = {
  report: { method: 'GET', path: '/reports/shift-revenue', requiresAuth: true },
  invoices: { method: 'GET', path: '/reports/shift-revenue/invoices', requiresAuth: true },
  export: { method: 'GET', path: '/reports/shift-revenue/export', requiresAuth: true },
} as const satisfies ApiModuleEndpoints
